<template>
  <transition name="fade" mode="out-in">
    <v-app>
      <navigation-drawer-component></navigation-drawer-component>
      <app-bar-component></app-bar-component>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <v-snackbar v-model="snackbar.active" color="eon">
        {{ snackbar.message }}
      </v-snackbar>
      <BaseDialogComponent></BaseDialogComponent>
    </v-app>
  </transition>
</template>
<style>
/* Estilos globales para tema oscuro */
.v-application {
  background-color: #121212 !important;
  color: #e0e0e0 !important;
}

.v-card__title,
.v-card__subtitle,
.v-card__text {
  color: #e0e0e0 !important;
}

.v-data-table {
  background-color: #1e1e1e !important;
  color: #e0e0e0 !important;
}

.v-data-table thead th {
  color: #e0e0e0 !important;
}

.v-data-table tbody tr {
  color: #e0e0e0 !important;
}

.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background-color: #2e2e2e !important;
}

.theme--dark.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.theme--dark.v-input input,
.theme--dark.v-input textarea {
  color: #e0e0e0 !important;
}

.theme--dark.v-label {
  color: rgba(255, 255, 255, 0.7) !important;
}

.v-list-item__title,
.v-list-item__subtitle {
  color: #e0e0e0 !important;
}

.theme--dark.v-sheet {
  background-color: #1e1e1e !important;
  color: #e0e0e0 !important;
}
</style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AppBarComponent from './components/AppBarComponent.vue'
import LoaderComponent from './components/LoaderComponent'
import NavigationDrawerComponent from './components/NavigationDrawerComponent.vue'
import BaseDialogComponent from './components/BaseDialogComponent.vue'

export default {
  name: 'App',

  components: { LoaderComponent, NavigationDrawerComponent, AppBarComponent, BaseDialogComponent },

  async mounted() {
    // El tema oscuro está configurado globalmente en vuetify.js
    // Los colores de cada módulo se aplican mediante setThemeByModule() en main.js
    // cuando el usuario navega a un módulo específico
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
      snackbar: 'getSnackbar',
      token: 'getToken',
    }),
  },

  methods: {
    ...mapActions('capacitador', ['fetchCapacitadores']),
    ...mapActions('aula', ['fetchAulas']),
    ...mapActions('curso', ['fetchCursos']),
    ...mapActions('cursoProgramado', ['fetchCursosProgramados']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignados']),
    ...mapActions('categoriaCurso', ['fetchCategoriasCursos']),
    ...mapActions('estatusCurso', ['fetchEstatusCurso']),
    ...mapActions('estatusCursoPersonal', ['fetchEstatusCursoPersonal']),
    ...mapActions('estatusAula', ['fetchClassroomStatus']),
    ...mapActions('tipoCurso', ['fetchCourseTypes']),

    ...mapActions('estatusEstudios', ['fetchEstatusEstudios']),
    ...mapActions('calibre', ['fetchCalibres']),
    ...mapActions('tipoArma', ['fetchTiposArma']),
    ...mapActions('marcaArma', ['fetchMarcaArma']),
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapActions('estatusArma', ['fetchEstatusArma']),
    ...mapActions('arma', ['fetchArmas']),
    ...mapActions('tipoAsignacionArma', ['fetchTipoAsignacion']),
    ...mapActions('tipoEntregaArma', ['fetchTiposEntrega']),
    ...mapActions('licenciaOficialColectiva', ['fetchLocs']),

    ...mapActions('personal', ['fetchPersonal']),

    ...mapActions('respetoPrincipios', ['fetchRespetoPrincipios']),
    ...mapActions('principio', ['fetchPrincipios']),
    ...mapActions('reactivo', ['fetchReactivos']),
    ...mapActions('frecuenciaRespetoPrincipio', ['fetchFrecuenciaRespetoPrincipio']),
    ...mapActions('periodicidad', ['fetchPeriodicidad']),
    ...mapActions('resultado', ['fetchResultados']),
    ...mapActions('productividad', ['fetchProductividad']),
    ...mapActions('funcion', ['fetchFunciones']),
    ...mapActions('indicador', ['fetchIndicadores']),
    ...mapActions('frecuenciaProductividad', ['fetchFrecuenciaProductividad']),
    ...mapActions('actoRelevante', ['fetchActosRelevantes']),

    ...mapActions('tipoItem', ['fetchTiposItem']),

    ...mapActions('item', ['fetchItemsByType']),

    ...mapActions('preaspirante', ['fetchPreaspirantes']),

    ...mapActions('candidato', ['fetchCandidatos']),
    ...mapActions('categoria', ['fetchCategorias']),

    ...mapActions('sede', ['fetchSedes']),
    ...mapActions('subsede', ['fetchSubsedes']),
    ...mapActions('puesto', ['fetchPuestos']),
    ...mapActions('dependencia', ['fetchDependencias']),

    ...mapActions('estudio', ['fetchTipoEstudios']),

    ...mapActions('perfil', ['fetchPerfiles']),
    ...mapActions('estadoCivil', ['fetchEstadoCivil']),
    ...mapActions('tipoNacionalidad', ['fetchTipoNacionalidad']),
    ...mapActions('municipio', ['fetchMunicipios']),
    ...mapActions('estado', ['fetchEstados']),

    ...mapActions('estatusPersonal', ['fetchEstatusPersonal']),
    ...mapActions('tipoDocumento', ['fetchTipoDocumento']),

    ...mapActions('preaspirante', ['fetchAspirantes']),

    ...mapActions('rama', ['fetchRamas']),
    ...mapActions('region', ['fetchRegiones']),
    ...mapMutations(['DISABLE_LOADER']),
  },
}
</script>
